module.exports = __webpack_public_path__ + "static/media/plus-icon-add.3cc6697d.svg";